import React, { useEffect, useState } from "react";
import "../../Styles/PenText.css";
import Typist from "react-typist";

const PenText = ({ text }) => {
  const [pentext, setpentext] = useState(true);

  return (
    <div className={pentext ? "PenText_one-left" : "PenText_one-left-delet"}>
      <div className="PenText_one-left-item">
        <button
          className="PenText_one-left-item-delete"
          onClick={() => setpentext((s) => !s)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <p className="PenText_one-left-item-text">
          {text && <Typist>{text}</Typist>}
        </p>
        {/* <img
                    className="PenText_one-left-item-svg-polygon"
                    src={Polygon}
        /> */}
      </div>

      <div className="PenText_one-left-item-svg">
        <img
          className="PenText_one-left-svg"
          src="/imgs/Common/pen.svg"
          alt="pen image"
        />
      </div>
    </div>
  );
};

export default PenText;
